module.exports = __webpack_public_path__ + "static/Burst2-cd7e880a57200b18c5c04bd39012c23b.jpg";